(function() {
    'use strict';

    angular.module('user')
        .controller('AllowedIpListController', AllowedIpListController);

    AllowedIpListController.$inject = ['$state', 'allowedIpDataSrvc', 'allowedIpSrvc', 'lodashService', 'notificationSrvc', 'allowedIpMessagesConst', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'allowedIpPermissionsConst', 'filterQuerySrvc'];

    function AllowedIpListController($state, allowedIpDataSrvc, allowedIpSrvc, lodashService, notificationSrvc, allowedIpMessagesConst, datatableDefaultPageSizeValueConst, checkSearchSrvc, allowedIpPermissionsConst, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.allowedIpRows = [];
        self.allowedIpCols = [{
            title: 'IP',
            value: 'ip',
            searchable: true,
            orderable: true,
        }, {
            title: 'Opis',
            value: 'description',
            searchable: true,
            orderable: true,
        }];
        self.modelPermissions = allowedIpPermissionsConst;

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.searchQuery = {
            ip: null,
            description: null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getAllowedIps();
        }

        function getAllowedIps(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    ip: self.searchQuery.ip,
                    description: self.searchQuery.description,
                    ordering: self.searchQuery.ordering
                };
            }
            return allowedIpDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.allowedIpRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getAllowedIps);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.allowedIp.create');
        }

        function onEdit(row) {
            $state.go('layout.allowedIp.update', { pk: row.pk });
        }

        function onDelete(row) {
            return allowedIpSrvc.remove(row.ip, row.pk, function(response) {
                notificationSrvc.notification("success", allowedIpMessagesConst.delete);
                lodashService.remove(self.allowedIpRows, { pk: row.pk });
                return response;
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getAllowedIps();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getAllowedIps();
        }
    }
})();
